// extracted by mini-css-extract-plugin
export var drawerPaper = "_2b-0";
export var itemCard = "_2b-1";
export var itemImage = "_2b-2";